import React from "react";
import { makeStyles } from '@material-ui/styles';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Parallax } from 'react-parallax';
import bgImage from "../../resources/images/reviews_bg.jpg";

import Container from "../../../../../base/components/container.js";
import I18n from "../../../../../base/i18n.js.jsx";

import IcWhiteArrowLeft from "../../../../../resources/icons/arrows/ic_white_arrow_left.js";
import IcWhiteArrowRight from "../../../../../resources/icons/arrows/ic_white_arrow_right.js";

import ReviewCard from "./review_card.js";

const blockStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.white,
    overflow: "hidden",
    height: "400px",
    position: "relative",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    padding: "32px 0px 20px",
    ['@media (max-width: 992px)']: {
      height: "320px",
      padding: "30px 0px 16px",
    },
    ['@media (max-width: 768px)']: {
      height: "220px",
      padding: "30px 24px 16px",
    },
    "&:after": {
      content: "' '",
      position: "absolute",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      backgroundColor: "rgba(26, 26, 26, 0.7)"
    },
    "& .slick-slider": {
      height: "100%",
      padding: "68px 0px 58px",
      ['@media (max-width: 992px)']: {
        padding: "54px 0px 54px",
      },
      ['@media (max-width: 768px)']: {
        padding: "30px 0px 20px",
      },

    },
    "& .slick-list": {
      height: "100%"
    },
    "& .slick-track": {
      height: "100%"
    },
    "& .slick-slide": {
      height: "100%"
    },
    "& .slick-slide > div": {
      height: "100%"
    },
    "& .slick-arrow": {
      position: "absolute",
      top: "46%",
      ['@media (max-width: 768px)']: {
        display: "none"
      },
    },
    "& .slick-prev": {
      left: "-18%",
      zIndex: 1,
    },
    "& .slick-next": {
      right: "-18%",
      zIndex: 1,
    },
    "& .slick-dots": {
      bottom: "-15px",
      "& ul": {
        padding: "0px",
        "& li": {
          pointerEvents: "none",
          height: "10px",
          width: "10px",
          backgroundColor: "transparent",
          borderRadius: "5px",
          border: `1px ${theme.palette.white} solid`,
          margin: "0px 6px",
          ['@media (max-width: 768px)']: {
            height: "8px",
            width: "8px",
            borderRadius: "4px",
            margin: "0px 5px",
          },
        },
        "& li.slick-active": {
          backgroundColor: theme.palette.white
        },
        "& li:first-child": {
          marginLeft: "0px"
        },
        "& li:last-child": {
          marginRight: "0px"
        }
      }
    }
  },
  content: {
    position: "relative",
    zIndex: "1",
    height: "100%"
  },
  titleBlock: {
    position: "absolute",
    left: "0px",
    top: "0px",
    width: "100%"
  },
  titleContainer: {
  },
  sliderContainer: {
    height: "100%",
    width: "57%",
    margin: "0 auto",
    ['@media (max-width: 992px)']: {
      width: "65%",
    },
    ['@media (max-width: 768px)']: {
      width: "100%",
    },
  },
  title: {
    display: "block",
    fontSize: "38px",
    textTransform: "uppercase",
    // color: theme.palette.greenMain,
    ['@media (max-width: 992px)']: {
      fontSize: "24px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
      lineHeight: "24px"
    },
  },
}));

const ReviewsBlock = () => {
  const classes = blockStyles();

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <IcWhiteArrowRight />,
    prevArrow: <IcWhiteArrowLeft  />,
    // TODO: Resolve dots layout when reviews count will increased
    appendDots: dots => (
      <div>
        <ul> {dots} </ul>
      </div>
    ),
    customPaging: i => (
      <div />
    )
  }

  return (
    <Parallax bgImage = { bgImage }
              strength = { 350 }>
      <div className = { classes.root }>
        <div className = { classes.content } >
          <div className = { classes.titleBlock } >
            <Container className = { classes.titleContainer } >
              <span className = { classes.title } >
                { I18n.t("web.page.index.customer_reviews.title") }
              </span>
            </Container>
          </div>
          <div className = { classes.sliderContainer } >
            <Slider {...settings} className = { classes.slider } >
              {
                I18n.t("web.page.index.customer_reviews.reviews").map((review, index) => {
                  return <ReviewCard review = { review }
                                     key = { index } />
                })
              }
            </Slider>
          </div>
        </div>
      </div>
    </Parallax>
  );
}

export default ReviewsBlock;
